import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">精彩片段</h2>
          <p className="mt-2 text-sm text-foreground-500">热门精选 · 先睹为快</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-foreground-800 group-hover:text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}